module.exports = __webpack_public_path__ + "media/cash_register.142ac813.mp3";